// extracted by mini-css-extract-plugin
export default {"cls1":"rf7d63CGaQJEPDJM2JeV","cls2":"gL3Il24zY3SdAx10DQIg rf7d63CGaQJEPDJM2JeV"};